// extracted by mini-css-extract-plugin
export default {"icons":"SocialLinks-module__icons--GXea7","icon":"SocialLinks-module__icon--lY49c"};